import type { Proposal, ApprovalCopy } from '@/frontend/features/Fde/WorkApprovals/types'

export default function ProposalDetails({ proposal, copy }: { proposal: Proposal; copy: ApprovalCopy }) {
  return <details className="group mt-7 border-t py-4">
    <summary className="cursor-pointer text-xs text-muted-foreground transition-colors hover:text-foreground">{copy.ui.details}</summary>
    <div className="mt-4 space-y-5 break-words text-sm">
      <dl className="space-y-2 text-muted-foreground">
        <div><dt className="inline">{copy.ui.task}: </dt><dd className="inline">{proposal.task_title}</dd></div>
        <div><dt className="inline">{copy.revision}: </dt><dd className="inline">{proposal.revision}</dd></div>
        <div><dt className="inline">{copy.authorized_by}: </dt><dd className="inline">{proposal.approvers.join(', ')}</dd></div>
        <div><dt className="inline">{copy.delivery}: </dt><dd className="inline">{copy.deliveries[proposal.delivery_status]}</dd></div>
      </dl>
      <p className="text-xs text-muted-foreground">{copy.delivery_note}</p>
      {proposal.delivery_error && <p className="whitespace-pre-wrap text-xs text-muted-foreground">{proposal.delivery_error}</p>}
      {proposal.slack_warning && <p role="alert" className="text-sm text-muted-foreground">{proposal.slack_warning}</p>}
      {!!proposal.events.length && <section aria-label={copy.history} className="space-y-3">
        <h2 className="text-sm font-medium">{copy.history}</h2>
        <ol className="space-y-4 border-l pl-4">{proposal.events.map((event, index) => <li key={index}>
          <p>{event.user_name} · {copy.decisions[event.decision]}</p>
          <p className="text-xs text-muted-foreground">{event.at_label} · {copy.revision} {event.revision}</p>
          {event.reason && <p className="mt-1 whitespace-pre-wrap">{event.reason}</p>}
          <details className="mt-2"><summary className="cursor-pointer text-xs text-muted-foreground">{copy.card.limits}</summary><p className="mt-1 whitespace-pre-wrap">{event.scope.limits}</p></details>
        </li>)}</ol>
      </section>}
    </div>
  </details>
}
